import axios from 'axios'

const AuthService = {
  async getCurrentUser () {
    return axios.get('auth/me')
  },

  async signIn (params = {}) {
    return axios.post('auth/login', params)
  },

  async signInUnified (params = {}) {
    return axios.post('auth/unified-login', params)
  },

  async changePassword (params = {}) {
    return axios.post('auth/password', params)
  },

  async sendPasswordChangeOtp () {
    return axios.post('auth/password-otp/send')
  },

  async verifyPasswordChangeOtp (otp) {
    return axios.post('auth/password-otp/verify', { otp })
  },

  async logout () {
    return axios.post('auth/logout')
  }
}

export default AuthService
